export default "__VITE_ASSET__yFeETYuyvPMnsvpVxNz0MQ__ 480w, __VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__ 745w";